import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import WhyChooseUs from "./components/WhyChooseUs";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";

function App() {
  const [bookingModalOpen, setBookingModalOpen] = useState(false);

  const handleBookNow = () => {
    setBookingModalOpen(true);
  };

  return (
    <div className="App">
      <Header onBookNow={handleBookNow} />
      <Hero onBookNow={handleBookNow} />
      <HowItWorks />
      <Testimonials />
      <WhyChooseUs />
      <FAQ />
      <Gallery />
      <CTA onBookNow={handleBookNow} />
      <Footer />
      <BookingModal 
        isOpen={bookingModalOpen} 
        onClose={() => setBookingModalOpen(false)} 
      />
    </div>
  );
}

export default App;
